import { render } from "./ClientePrecioView.vue?vue&type=template&id=22342e12&scoped=true"
import script from "./ClientePrecioView.vue?vue&type=script&lang=js"
export * from "./ClientePrecioView.vue?vue&type=script&lang=js"

import "./ClientePrecioView.vue?vue&type=style&index=0&id=22342e12&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22342e12"]])

export default __exports__